module.exports = __webpack_public_path__ + "static/media/19ESCAP31.8092180b.jpg";